import React from 'react';
import { User } from 'lucide-react';
import type { RegisteredEventPerson } from '../../types';

const RegisteredPeopleLinks: React.FC<{ people?: RegisteredEventPerson[] }> = ({ people }) => {
  const unique = new Map<number, RegisteredEventPerson>();
  for (const person of people || []) {
    if (!unique.has(person.person_id) || person.review_status === 'confirmed') unique.set(person.person_id, person);
  }
  if (!unique.size) return null;
  return <div className="flex flex-wrap gap-2" aria-label="Registry matches">
    {Array.from(unique.values()).map(person => <a
      key={person.person_id}
      href={`/persons/${person.person_id}/view`}
      onClick={event => event.stopPropagation()}
      className="inline-flex flex-wrap items-center gap-1 rounded-md border border-border-default px-2 py-1 text-xs text-accent-primary hover:bg-surface-hover"
    >
      <User size={12} />
      <span className="font-medium">{person.person_name || `Person #${person.person_id}`}</span>
      <span className="text-text-muted">· {person.review_status === 'confirmed' ? 'Confirmed match' : 'Possible match'}</span>
    </a>)}
  </div>;
};

export default RegisteredPeopleLinks;
